// Create MutationObserver
const observer = new MutationObserver((mutationsList, observer) => {
  // Check new mutations
  for (let mutation of mutationsList) {
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
      // Get element when has class 'promo-banner--open'
      const promoElement = document.querySelector('.js-promo-countdown.promo-banner--open')
      const mainHeader = document.querySelector('.js-header')
      const homeMainContent = document.querySelector('.template-index #main-content')
      const notHomeMainContent = document.querySelector('body:not(.template-index) #main-content')
      if (promoElement) {
        const promoHeight = promoElement.clientHeight
        const headerHeight = mainHeader.clientHeight

        if (mainHeader) {
          mainHeader.style.top = `${promoHeight}px`
        }

        if (homeMainContent && window.innerWidth < 768) {
          homeMainContent.style.paddingTop = `${promoHeight}px`
        }

        if (notHomeMainContent) {
          notHomeMainContent.style.paddingTop = `${promoHeight + headerHeight}px`
        }
      }
    }
  }
})

const targetNode = document.body

// Set options for MutationObserver
const observerConfig = {
  attributes: true,
  attributeFilter: ['class'],
  subtree: true
}

observer.observe(targetNode, observerConfig)
